var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "75px",
    height: "75px",
    viewBox: "0 0 75 75",
    enableBackground: "new 0 0 75 75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B4E894",
    d: "M71.834,54.319c-0.549-0.183-1.169-0.21-1.757-0.21 c-16.017-0.012-32.032-0.009-48.049-0.009c-0.332,0-0.665,0-1.125,0c0-0.453,0-0.784,0-1.115c0-15.94,0-31.879,0-47.817 c0-0.363,0.007-0.726-0.016-1.088c-0.155-2.429-2.826-3.86-4.927-2.632c-1.281,0.747-1.678,1.915-1.676,3.35 c0.017,17.365,0.011,34.729,0.011,52.093c0,0.259,0.002,0.519,0.016,0.776c0.044,0.876,0.426,1.592,1.054,2.182 c0.771,0.725,1.715,0.868,2.734,0.867c17.364-0.01,34.729-0.007,52.092-0.008c0.233,0,0.467,0.001,0.7-0.013 c1.608-0.096,2.834-1.249,3.072-2.884C74.181,56.331,73.291,54.8,71.834,54.319z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B4E894",
    d: "M26.722,20.792c0.446,0.107,0.926,0.101,1.39,0.101 c8.319,0.005,16.639,0.004,24.961,0.004c0.304,0,0.61,0,1.032,0c0,0.436,0,0.744,0,1.05c0,8.242,0,16.483,0.002,24.726 c0,0.312-0.006,0.623,0.008,0.933c0.079,1.614,1.291,2.944,2.834,3.118c1.699,0.194,3.198-0.759,3.63-2.364 c0.125-0.466,0.131-0.975,0.131-1.462c0.006-9.589-0.034-19.18,0.033-28.769c0.018-2.343-1.495-3.888-3.889-3.871 c-9.589,0.071-19.178,0.029-28.768,0.029c-0.233,0-0.466-0.002-0.699,0.01c-1.613,0.082-2.942,1.297-3.111,2.841 C24.087,18.867,25.092,20.399,26.722,20.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B4E894",
    d: "M60.699,67.204c-0.078-1.799-1.489-3.141-3.28-3.146 c-1.792-0.004-3.231,1.336-3.297,3.126c-0.043,1.213-0.043,2.431,0,3.646c0.06,1.778,1.517,3.162,3.277,3.17 c1.761,0.006,3.216-1.372,3.3-3.15c0.029-0.594,0.004-1.188,0.004-1.783C60.703,68.445,60.729,67.825,60.699,67.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B4E894",
    d: "M7.828,14.303c-0.594-0.028-1.19-0.004-1.784-0.005 c-0.621,0-1.242-0.023-1.862,0.004c-1.785,0.077-3.163,1.504-3.178,3.269c-0.015,1.758,1.363,3.24,3.136,3.306 c1.239,0.046,2.483,0.049,3.723,0c1.747-0.071,3.071-1.508,3.08-3.263C10.951,15.819,9.615,14.389,7.828,14.303z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.e8f4398dce12470d5ae5431d8de8fb6b.svg";
export { ForwardRef as ReactComponent };